import queryString from "query-string";

export function switchCountry(con) {
  switch (con) {
    case "in":
      return "India";
    case "br":
      return "Brazil";
    case "ar":
      return "Argentina";
    case "kr":
      return "South Korea";
    case "uk":
      return "UK";
    case "us":
      return "USA";
    case "mx":
      return "Mexico";
    case "es":
      return "Spain";
    case "co":
      return "Colombia";
    case "de":
      return "Germany";
    case "it":
      return "Itly";
    case "id":
      return "Indonesia";
    case "th":
      return "Thiland";
    case "ca":
      return "Canada";
    case "fr":
      return "France";
    case "vn":
      return "Vietnam";
    default:
      return "India";
  }
}

export const fetchQueryParams = string => queryString.parse(string);
